
// user
let initialState = {
    
    id: 0,
    isAuth: false,
    firstName: null,
    lastName: null,
    vkData: {},
    
    birthDayInput: '',
    birthMonthInput: '',
    birthYearInput: '',

    birthDay: 0,
    birthMonth: 0,
    birthYear: 0,

    arkanes: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    innerArkanes: [0, 0, 0, 0, 0],

    soulAge: 0,
    innerChild: 0,
    longKarma: '',
    genderArkanes: { u: 0, m: 0, f: 0, n: 0 },
    energyArkanes: { m: 0, f: 0, k: 0 },
    digitsCount: new Array(23).fill(0),
    maleIsFlipped: false,
    femaleIsFlipped: false,
}

export const userReducer = (state = initialState, action) => {

    switch (action.type) {

        // Bad but Fast Practice
        case USER_UPDATE_STATE_PARAMS:
            return {
                ...state,
                ...action.payload,
            };

        case USER_UPDATE_B_DAY:
            if ( action.payload.length > 1 || ( parseInt(action.payload, 10) > 3 && parseInt(action.payload, 10) <= 9 ) ) {
                callFunc(action.focusNextFunc);
            }
            return {
                ...state,
                birthDayInput: action.payload,
            };
        case USER_UPDATE_B_MONTH:
            if ( action.payload.length > 1 || ( parseInt(action.payload, 10) > 1 && parseInt(action.payload, 10) <= 9 ) ) {
                callFunc(action.focusNextFunc);
            }
            return {
                ...state,
                birthMonthInput: action.payload,
            };
        case USER_UPDATE_B_YEAR:
            return {
                ...state,
                birthYearInput: action.payload,
            };

        default:
            break;
    }

    return state;
}

export const USER_UPDATE_B_YEAR = 'USER_UPDATE_B_YEAR';
export const updateBirthYear = (val, focusNextFunc=null) => {
    return {
        type: USER_UPDATE_B_YEAR,
        payload: cleaner(val, 4),
        focusNextFunc: focusNextFunc,
    };
}

export const USER_UPDATE_B_MONTH = 'USER_UPDATE_B_MONTH';
export const updateBirthMonth = (val, focusNextFunc=null) => {
    return {
        type: USER_UPDATE_B_MONTH,
        payload: cleaner(val),
        focusNextFunc: focusNextFunc,
    };
}

export const USER_UPDATE_B_DAY = 'USER_UPDATE_B_DAY';
export const updateBirthDay = (val, focusNextFunc=null) => {
    return {
        type: USER_UPDATE_B_DAY,
        payload: cleaner(val),
        focusNextFunc: focusNextFunc,
    };
}

// Bad but Fast Practice
export const USER_UPDATE_STATE_PARAMS = 'USER_UPDATE_STATE_PARAMS';
export const updateUserStateParams = (newParams) => {
    return {
        type: USER_UPDATE_STATE_PARAMS,
        payload: newParams,
    };
}

const cleaner = (val, maxLen=2) => {
    return String(val).replace(/\D/gi, '').substr(0, maxLen);
}

const callFunc = ( funcToCall = null ) => {

    //console.log(typeof funcToCall, typeof funcToCall !== 'function')

    if ( !funcToCall || typeof funcToCall !== 'function' ) {
        return false;
    }
    
    setTimeout( () => {
        funcToCall()
    }, 0 );
}